var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-timeline-item',_vm._b({attrs:{"hide-timestamp":_vm.isTimeHidden,"timestamp":_vm.timelineItemTime}},'el-timeline-item',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }